// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","681":"indikator-mutu"}[chunkId] + "." + {"443":"a9658991","681":"3e82b3e2"}[chunkId] + ".css";
};